import React from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  AccountInfoType,
  ContactFormType,
  FormServFieldType,
  McrContactType,
} from '../../../../../shared/types';
import {
  HIDE_CONTACT_DETAILS_FIELDS,
  TEMPORARY_HIDDEN_FIELDS,
} from '../../../../../shared/constants';
import { getDisplayValueFromField } from '../../../../utils';
import { ContactFields } from '../styles';
import { LEFT_PANE_FIELD_NAMES } from '../../constants';

type ContactDetailsProps = {
  contactForm: ContactFormType;
  contactData: McrContactType;
  accountInfo?: AccountInfoType;
};

const ContactDetails = (props: ContactDetailsProps) => {
  const { contactForm, contactData, accountInfo } = props;
  const { t, i18n } = useTranslation();
  const fields =
    contactForm && contactForm.fields && contactForm.fields.length > 0
      ? contactForm.fields
      : [];

  return (
    <ContactFields>
      {fields
        .filter(
          (field: FormServFieldType) =>
            !LEFT_PANE_FIELD_NAMES.includes(field.name) &&
            field.visible &&
            ![
              ...HIDE_CONTACT_DETAILS_FIELDS,
              ...TEMPORARY_HIDDEN_FIELDS,
            ].includes(field.name) &&
            !field.deleted,
        )
        .map((field: FormServFieldType) => {
          const value = field.custom
            ? get(contactData, ['fields', field.name], '')
            : get(contactData, [field.name], '');
          const fieldId = get(field?.choices?.[value], ['id'], value);
          return (
            <div key={field.id} className={`field ${field.field_class}`}>
              <div className="label">
                {i18n.exists(
                  `contacts.import_contact.default_fields.contact.${field.name}`,
                )
                  ? `${t(
                      `contacts.import_contact.default_fields.contact.${field.name}`,
                    )}`
                  : field.label}
              </div>
              <div className="value">
                {i18n.exists(
                  `contacts.import_contact.form_choices.${field.name}.${fieldId}`,
                )
                  ? `${t(
                      `contacts.import_contact.form_choices.${field.name}.${fieldId}`,
                    )}`
                  : getDisplayValueFromField({
                      field,
                      rowValues: contactData,
                      contactLists: [],
                      emptyPlaceholder: '-',
                      accountInfo,
                    })}
              </div>
            </div>
          );
        })}
    </ContactFields>
  );
};

export default ContactDetails;
